// Donation Model
cv.Donation = Backbone.RESTModel.extend({
  defaults : {
    'recipient.type' : 'campaign',

    'amount' : 0,
    'display_name' : '',
    'first_name' : '',
    'last_name' : '',
    'comment' : '',
    'anonymous' : 0,

    'custom_values' : {},

    'email' : '',
    'line1' : '',
    'line2' : '',
    'city' : '',
    'state' : '',
    'zipcode': '',
    'country' : 'US',
    'giftaid' : 0
  },

  saveMap : {
    'recipient' : {
      'id' : 'recipient.id',
      'type' : 'recipient.type'
    },

    'amount' : 'amount',
    'display_name' : 'display_name',
    'first_name' : 'first_name',
    'last_name' : 'last_name',
    'comment' : 'comment',
    'anonymous' : 'anonymous',

    'custom_values' : 'custom_values',

    'email' : 'email',
    'line1' : 'line1',
    'line2' : 'line2',
    'city' : 'city',
    'state' : 'state',
    'zipcode': 'zipcode',
    'country' : 'country',
    'giftaid' : 'giftaid',
    'status' : 'status',
    'created_at' : 'created_at'
  },

  urlRoot: function(){
    return cv.api_path + '/donations';
  },

  initialize: function(){
    console.log('Donation model initialized.');
  }
});
Cocktail.mixin(cv.Donation, cv.mixins.SyncModel);

// Donations Collection
cv.Donations = Backbone.Collection.extend({
  initialize: function(){
    console.log('Donation collection initialized.');
  },

  url: function() {
    return cv.api_path + "/donations?" + $.param(this.params);
  },

  model: cv.Donation
});
Cocktail.mixin(cv.Donations, cv.mixins.PaginateModel);
